module.exports = __webpack_public_path__ + "static/tour-ea05273fbfe2b381e209d602a626d896.png";